import { useLocation } from 'react-router-dom';

const useLocationSearch = (key: string): string | null => {
  const { search } = useLocation();
  return new URLSearchParams(search).get(key);
};

export default useLocationSearch;
